import { Controller } from '@hotwired/stimulus';
import debounce from 'lodash/debounce';
import Platform from '../../helpers/platform';

// Connects to data-controller="home--search"
export default class extends Controller {
  static targets = ['form', 'input', 'searchContainer', 'homeContent'];

  connect() {
    this.submit = debounce(this.submit, 300).bind(this);
    this.boundClickOutside = this.clickOutside.bind(this);
  }

  submit() {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit();
    }
  }

  clear(event) {
    if (event.target.value === '') {
      this.formTarget.requestSubmit();
    }
  }

  toggleHomeContent() {
    this.homeContentTarget.classList.toggle('hidden');
    this.searchContainerTarget.classList.toggle('hidden');
  }

  toggleSearch() {
    this.searchContainerTarget.classList.toggle('hidden');

    if (this.hasHomeContentTarget) {
      this.homeContentTarget.classList.toggle('hidden');
    }

    const isVisible = !this.searchContainerTarget.classList.contains('hidden');
    if (isVisible) {
      if (this.hasInputTarget) {
        if (!Platform.isMobileDevice()) {
          this.inputTarget.focus(); // Focus the input when shown
        }
      }
      document.addEventListener('click', this.boundClickOutside);
    } else {
      this.inputTarget.value = '';
      document.removeEventListener('click', this.boundClickOutside);
      this.formTarget.requestSubmit();
    }
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      const isVisible =
        !this.searchContainerTarget.classList.contains('hidden');
      if (isVisible) {
        this.toggleSearch();
      }
    }
  }

  disconnect() {
    document.removeEventListener('click', this.boundClickOutside);
    setTimeout(() => {
      this.toggleHomeContent();
    }, 100);
  }
}
